/**
 * @file jobSearch.ts
 *
 * @fileoverview Provides blog detail query.
 */

import { gql } from '@apollo/client';
import ORG_TEASER_LARGE_FRAGMENT from '~/jobiqo/components/Organization/Teaser/Large/graphql/fragments/organizationTeaserLargeFragment.js';

export const blogDetailQuery = (appConfig: any) => {
  const BLOG_ADS_FEATURE_ACTIVE = appConfig.BLOG_ADS_FEATURE_ACTIVE;

  return gql`
   ${ORG_TEASER_LARGE_FRAGMENT}
   query getBlogPost($path: String!, $language: String!) {
     route(path: $path, language: $language) {
        ... on ErrorResponse {
          code
          reason
        }
        ... on RedirectResponse {
          code
          target
        }
        ... on ContentResponse {
          content {
            ... on BlogPost {
              id
              title
              author
              date
              modifiedDate
              image(style: "blog_cover") {
                url
                width
                height
                alt
                title
                caption
              }
              url {
                path
              }
              category {
                label
                tid
              }
              tags {
                label
                url {
                  path
                }
              }
              featured
              blogPostRows {
                ... on BlogJobTeasersParagraph {
                  bundle
                  url {
                    path
                  }
                  jobs {
                    ... on Job {
                      id
                      title
                      organization
                      organizationProfile {
                        name
                        url {
                          path
                        }
                        urlNoPrefix
                        logo(style: "job_squared_logo_medium") {
                          url
                          alt
                          title
                        }
                        isPremium
                      }
                      url {
                        path
                      }
                      urlNoPrefix
                      logo(style: "job_squared_logo_small") {
                        url
                      }
                      employmentType {
                        tid
                        label
                      }
                      occupationalField {
                        tid
                        label
                      }
                      address
                      published
                      expiration
                      pause
                      formattedOriginalPublished
                      formattedPublished
                      formattedExpiration
                      formattedPause
                      isFeatured
                      isHighlight
                      isTopJob
                      bookmarked
                    }
                  }
                }
                ... on BlogQuoteParagraph {
                  bundle
                  author
                  quote: text
                  image(style: "medium") {
                    alt
                    title
                    url
                  }
                }
                ... on BlogImageParagraph {
                  bundle
                  image(style: "extra_large") {
                    alt
                    title
                    height
                    url
                    width
                    caption
                  }
                }
                ... on BlogTextImageParagraph {
                  bundle
                  text
                  image(style: "large") {
                    url
                    width
                    height
                    alt
                    title
                    caption
                  }
                  align
                }
                ... on BlogSimpleTextParagraph {
                  bundle
                  text
                }
                ... on BlogCtaParagraph {
                  description
                  bundle
                  button {
                    url
                    text
                  }
                  position
                }
                ... on BlogInsecureScriptParagraph {
                  bundle
                  scriptContent
                }
                ... on OrganizationProfileParagraph {
                  ...OrganizationTeaserLargeFragment
                }
                ${
                  BLOG_ADS_FEATURE_ACTIVE
                    ? `
                  ... on BlogAdUnitParagraph {
                    bundle
                    adUnitId
                  }
                `
                    : ``
                }
              }
              metatags {
                meta
                value
              }
            }
          }
      }
    }
  }
 `;
};
